import axios from 'axios'
import config from '../config'
import { getPatientToken } from '../utils'

const saveMoodTrackApi = async (params) => {
    const response = await axios({
        url:`${config.api.base_url}patient/add-mood-track`,
        method:"post",
        data:params,
        headers:{
            "Content-Type":"application/json",
            "Authorization": `Bearer ${getPatientToken()}`
        }
    })
    return response
}

export default saveMoodTrackApi